module.exports = __webpack_public_path__ + "img/bhim.75de9070.png";